import { IonButton, IonCol, IonGrid, IonInput, IonLabel, IonRow, IonText, useIonAlert, useIonRouter } from '@ionic/react';
import { useEffect, useState } from 'react';
import { User } from '../../models/data';
import { translation } from '../../models/translation';
import AuthServ from '../../services/auth';

interface SignUpProps {
  user: User | null
  refresh:any
}


const UpDateUserInfo: React.FC<SignUpProps> = (props) => {

  useEffect(() => {
    setFirstName(props.user?.firstName)
    setLastName(props.user?.lastName)
  }, [props.user?.firstName, props.user?.lastName])

  const siteText = translation();

  const lan = siteText.lan.replace("/", "")

  const toAccountArray = ["home", "signin"]

  //
  const [disable, setDisable] = useState(false);

  const [present] = useIonAlert();

  const authSvc = new AuthServ();

  const [eighteenYearsAgo] = useState(() => {
    let today = new Date();
    let upDate = today.setFullYear(today.getFullYear() - 18);
    let eighteenYearsAgo = new Date(upDate);
    return (`${eighteenYearsAgo.getFullYear()}-${('0' + (eighteenYearsAgo.getMonth() + 1)).slice(-2)}-${('0' + eighteenYearsAgo.getDate()).slice(-2)}`);
  })
  /*Form elements */
  const [firstName, setFirstName] = useState<any>();
  const [lastName, setLastName] = useState<any>();
  const [dateOfBirth, setDateOfBirth] = useState<any>();


  //
  const router = useIonRouter();


  //
  const onSubmit = async (e: any) => {
    e.preventDefault();

    setDisable(true);

    let userData = {
      name: `${firstName} ${lastName}`,
      first_name: firstName,
      last_name: lastName,
      meta:{date_of_birth: dateOfBirth}

    }
    await authSvc.updateUser(userData).then(
      m=>{
        if(m){
          props.refresh()
          setTimeout(()=>{
            window.location.reload();
          },1000)
        }
      }
    );
    return
  }



  /*Present success message */
  const presentSuccess = () =>
    present({
      cssClass: 'my-css',
      header: 'Account creation',
      message: siteText.signUpSuccess,
      buttons: [
        `${siteText.loginPrimary}`,
      ],
      onDidDismiss: (e) => {
        if (router.routeInfo.lastPathname && toAccountArray.some((item: string) => router.routeInfo.lastPathname?.includes(item))) {
          router.push(`/${lan}/account`, "forward", "push")
        } else {
          router.goBack()
        }
      },
    })

  //

  return (
    <IonGrid className='sw_sp_md'>
      <IonRow className='ion-justify-content-center ion-align-items-center innerBody'>
        <IonCol sizeSm='8' sizeMd='6'>
          <h3 className='ion-text-center ion-margin-bottom'>{siteText.completeInfoTitle}</h3>
          <form onSubmit={onSubmit}>
            <IonLabel>{siteText.signupFirstName}</IonLabel>
            <IonInput className='ion-margin-top ion-margin-bottom' type='text' value={firstName} placeholder={siteText.signupFirstNamePlaceHolder} required onIonChange={e => setFirstName(e.detail.value)}></IonInput>
            <IonLabel>{siteText.signupLastName}</IonLabel>
            <IonInput className='ion-margin-top ion-margin-bottom' type='text' value={lastName} placeholder={siteText.signupLastNamePlaceHolder} required onIonChange={e => setLastName(e.detail.value)}></IonInput>
            <IonLabel>{siteText.signupDateOfBirth}</IonLabel>
            <IonInput className='ion-margin-top ion-margin-bottom' type='date' max={eighteenYearsAgo} placeholder={siteText.signupDateOfBirth} required onIonChange={e => setDateOfBirth(e.detail.value)}></IonInput>
            <IonButton strong disabled={disable} type="submit" className='sw_mt_md'> <IonText color='light'>{siteText.completeInfoBtnText}</IonText></IonButton>

          </form>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default UpDateUserInfo;
